import React from 'react'
import { array, number, string } from 'prop-types'
import { EventTestimonialGrid } from '@/component/Primitive/Events'

const EventTestimonialGridWidget = ({ list, ...other }) => {
  const getImage = (imageList, context, ratio, size) =>
    imageList?.[`${context}_${ratio}_${size}`]?.[0]

  const listWithImage = list?.map((testimonial) => {
    const { speaker } = testimonial
    if (speaker)
      speaker.image = {
        alt: 'Event Image Placeholder',
        sizes: ['min-width(960px) 50vw', '100vw'],
        src: getImage(speaker?.images, 'speaker', '1x1', 320)?.url
      }
    return testimonial
  })
  return <EventTestimonialGrid list={listWithImage} {...other} />
}

EventTestimonialGridWidget.propTypes = {
  list: array,
  theme: string,
  rowLimit: number
}

export default EventTestimonialGridWidget
